/**
 * 결제 내역 페이지
 * FSD: pages/payment-history
 */

import React, { useState } from 'react';
import { TransactionList, CancelModal } from '@/features/subscription/payment-history';
import type { PaymentTransaction } from '@/entities/payment/model';

const PaymentHistoryPage: React.FC = () => {
  const [selectedTransaction, setSelectedTransaction] = useState<PaymentTransaction | null>(null);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleSelectTransaction = (transaction: PaymentTransaction) => {
    // 취소 가능한 상태 확인 (APPROVED 상태만 취소 가능)
    if (transaction.status === 'APPROVED') {
      setSelectedTransaction(transaction);
      setShowCancelModal(true);
    }
  };

  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
    setSelectedTransaction(null);
  };

  return (
    <div className="payment-history-page">
      <div className="page-header">
        <h1>결제 내역</h1>
        <p className="subtitle">지금까지의 모든 결제 내역을 확인할 수 있습니다</p>
      </div>

      <div className="page-content">
        <TransactionList onSelectTransaction={handleSelectTransaction} />
      </div>

      {showCancelModal && selectedTransaction && (
        <CancelModal
          transaction={selectedTransaction}
          onClose={handleCloseCancelModal}
          onSuccess={handleCloseCancelModal}
        />
      )}
    </div>
  );
};

export default PaymentHistoryPage;
